import { faList, faCheckCircle, faFilter } from '@fortawesome/pro-light-svg-icons'

import { FormField, InputSearch, SegmentedControl } from '@domain-group/suit-theme'

import useAssignTemplatePagePermissions from '../../hooks/useAssignTemplatePagePermissionsModal'

interface EntityFiltersProps {
  assignTemplatePagePermissionsPayload: ReturnType<typeof useAssignTemplatePagePermissions>,
  entityName: string,
}

const EntityFilters = (props: EntityFiltersProps) => {
  const {
    assignTemplatePagePermissionsPayload: {
      activeSegmentKey,
      callbacks: {
        setCurrentSegmentKey,
        setState,
      },
      filterString,
    },
    entityName,
  } = props

  return (
    <>
      <FormField label={`Filter ${entityName}`}>
        <InputSearch
          onChange={e => setState({ filterString: e.target.value })}
          value={filterString}
        />
      </FormField>

      <SegmentedControl
        activeButtonKey={filterString ? 'filtered' : activeSegmentKey}
        boxProps={{ marginTop: 'medium' }}
        buttons={[
          {
            key: 'all',
            icon: faList,
            label: 'All Items',
          },
          {
            key: 'selected',
            icon: faCheckCircle,
            label: 'Selected Items',
          },
          {
            disabled: !filterString,
            key: 'filtered',
            icon: faFilter,
            label: 'Filtered Items',
          },
        ]}
        onClick={key => setCurrentSegmentKey(key)}
      />
    </>
  )
}

export default EntityFilters
